import React, { useState } from 'react';
import { toast } from 'react-hot-toast';
import { LuTriangleAlert } from 'react-icons/lu';
import api from '../../services/api';
import ModalShell from '../ui/ModalShell';
import ElegirDiaPedido from './ElegirDiaPedido';
import { diaLargo } from './diasRuta';

// Elegir o cambiar el día de un pedido ya cargado (25-oct-2026): los días de su zona con lugar, o "es urgente"
// para el día siguiente. Lo usa la pestaña Semana.
export default function ReservarDiaSheet({ pedido, onCerrar, onListo }) {
    const [fecha, setFecha] = useState(pedido.rutaFecha || null);
    const [urgente, setUrgente] = useState(!!pedido.urgente);
    const [guardando, setGuardando] = useState(false);
    const guardar = async () => {
        setGuardando(true);
        try {
            const r = await api.post('/empresa/semana/reservar', { pedidoIds: [pedido.pedidoId], fecha, urgente });
            const m = r.data?.modo;
            toast.success(m === 'ENTRA' ? `Agendado para el ${diaLargo(fecha)}` : m === 'PEDIDO' ? 'Se lo pedimos a Dispenser La Tienda'
                : m === 'SIN_DIA' ? 'Quedó sin día' : `Reservado para el ${diaLargo(fecha)}`);
            onListo();
        } catch (e) { toast.error(e?.response?.data?.mensaje || 'No se pudo guardar'); setGuardando(false); }
    };
    return (
        <ModalShell titulo="¿Qué día va?" subtitulo={pedido.nombre} onCerrar={onCerrar}
            pie={
                <div className="flex gap-2">
                    <button type="button" onClick={onCerrar} className="flex-1 h-12 rounded-xl bg-chip text-secondary text-label font-black">Cancelar</button>
                    <button type="button" onClick={guardar} disabled={guardando} className="flex-[2] h-12 rounded-xl bg-brand-red text-white text-label font-black disabled:opacity-50">
                        {guardando ? 'Guardando…' : fecha ? `Reservar el ${diaLargo(fecha)}` : 'Dejar sin día'}
                    </button>
                </div>
            }>
            <div className="space-y-3">
                <p className="text-caption text-muted">{[pedido.direccion, pedido.motivo, pedido.zonaNombre].filter(Boolean).join(' · ')}</p>
                <ElegirDiaPedido consulta={{ pedidoId: pedido.pedidoId }} urgente={urgente} valor={fecha} onElegir={setFecha} onUrgente={() => setUrgente(true)} />
                <button type="button" onClick={() => { setUrgente(u => !u); if (urgente) setFecha(null); }} aria-pressed={urgente}
                    className={`w-full flex items-center gap-3 p-3.5 rounded-2xl border-2 text-left ${urgente ? 'border-brand-red bg-[rgba(201,52,31,0.06)]' : 'border-transparent bg-chip'}`}>
                    <LuTriangleAlert size={18} className={urgente ? 'text-brand-red' : 'text-muted'} />
                    <span className="flex-1 min-w-0">
                        <span className="block text-body font-black text-ink">Es urgente</span>
                        <span className="block text-caption text-muted">Pierde agua o no anda: va al día siguiente aunque esté completo.</span>
                    </span>
                    <span className={`w-11 h-6 rounded-full p-0.5 transition-colors ${urgente ? 'bg-[#C9341F]' : 'bg-black/15 dark:bg-white/15'}`}>
                        <span className={`block w-5 h-5 rounded-full bg-white shadow transition-transform ${urgente ? 'translate-x-5' : ''}`} />
                    </span>
                </button>
            </div>
        </ModalShell>
    );
}
